import React, { Component } from 'react';
import profileService from '../../services/WebProfileService';
import invoiceService from '../../services/WebInvoiceService';
import versionService from '../../services/WebVersionService';
import { withStyles } from '@material-ui/core/styles';
import Textfield from '../../components/shared/ppbn-textfield';
import ValidatePasswordField from '../../components/shared/validate-password-textfield';
import emailValidator from '../../components/shared/emailValidator';
import { Button, Checkbox, FormControlLabel, Snackbar } from '@material-ui/core';
import UsersTable from './UsersTable';
import EditUserDialog from './EditUserDialog';
import passwordValidator from 'common/passwordValidator';
import NumberFormat from 'react-number-format';
import packageJson from '../../../package.json'

const styles = theme => ({
    root: {
        margin: '1rem'
    },    
    textField: {
        marginLeft: 20,
        marginTop: 15,      
        marginRight: theme.spacing.unit,
        width: 250,
    },
    registerUserContainer: {
        marginTop:'30px'
    },
    registerUserInformationContainer : {
        marginTop:'15px',
        minHeight:'135px'
    },
    header : {
        marginLeft : '20px',
        fontSize: '18px',
        paddingTop : '20px'
    },
    btn: {
        marginTop:'1rem',
        marginLeft: '1rem'     
    },
    versionItem: {        
        display: "inlineBlock",        
    }, 
    versionItemLabel: {                
        display: "inlineBlock",
        width : '210px'
    },
    versionItemContainer: {
        marginLeft: "1.2rem",
        marginTop: "1rem",
        display: "flex",
        justifyItems: 'flex-start',
    }
});

const AMOUNT_LIMIT = 99.999;

function NumberFormatCustom(props) {
    const { inputRef, onChange, id, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                        id,
                    },
                });
            }}
            isAllowed={(values) => {
                return values.floatValue < AMOUNT_LIMIT
            }}
            id={id}
            allowEmptyFormatting
            decimalScale={3}
            fixedDecimalScale
            allowNegative={false}
        />);
}

class AdminContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
            apkInviteEmail: '',
            tax : '',
            taxSaveDisabled : true,
            tempPassword:'',
            skylineAccess:false,
            petroffAccess:false,
            mobileOnly:false,
            registrationStatus : {
                open : false,
                variant : 'success',                
            },
            users:[],
            userToEdit:null,
            backendVersion : ''
        }
    }

    onUserToRegisterInfoChange(target) {  
        const targetIsEmail = target.id === 'email';
        this.setState( prevState => ({            
            [target.id] : targetIsEmail ? target.value.toLowerCase() : target.value
        }));
    }

    onApkInviteEmailChange(target) {
        this.setState({
            apkInviteEmail: target.value.toLowerCase()
        });
    }

    async sendAppDownloadEmail(email, company, { clearTopEmailField = false } = {}) {
        const normalized = email.trim().toLowerCase();
        const result = await profileService.sendAppDownloadLinkAsync({
            email: normalized,
            company
        });
        if (result.success) {
            this.setState(() => ({
                ...(clearTopEmailField ? { apkInviteEmail: '' } : {}),
                registrationStatus: {
                    open: true,
                    variant: 'success',
                    message: 'App download email sent'
                }
            }));
        } else {
            this.setState({
                registrationStatus: {
                    open: true,
                    variant: 'failure',
                    message: result.message || 'Failed to send app download email'
                }
            });
        }
    }

    updateUsers() {        
        profileService.getUsers((response) => {
            if(response.success) {
                this.setState({users : response.users});
            } else {
                console.log('something went wrong')
            }
        });
    }

    async componentWillMount() {      
        this.updateUsers();
        const tax = await invoiceService.getTax();
        var backendVersion = '';
        try {
            const backendVersionResults = await versionService.getBackendVersion();
            backendVersion = backendVersionResults.version;
            
        } catch(error) {
            console.log("Failed to get the backend version")
        }
        this.setState({tax : (tax.partsTax * 100.00).toFixed(3),
                       backendVersion });
    }

    async onRegisterClick() {           
        const result = await profileService.registerUserAsync(this.state);                        

        if(result === 'failure') {
            this.setState( {                    
                tempPassword: '',
                registrationStatus : {
                    open : true,
                    variant : 'failure',
                    message : 'Failed to Register User'
                }
            })
        }  else if(result === 'success') {
            this.setState({
                registrationStatus : {
                    open : true,
                    variant : 'success',
                    message : 'New User Registered'
                },
                email: '',
                tempPassword: '',
            }, ()=> {
                this.updateUsers(); 
            });                
        }
        
    }

    isButtonDisabled(passwordValid) {
        const {email, skylineAccess, petroffAccess} = this.state;
        let isEnabled = passwordValid && emailValidator.isValid(email) && (skylineAccess || petroffAccess);
        return !isEnabled;
    }

    rowclicked(user) {
        this.setState({
            userToEdit : user
        });
    }    

    onUserEditCancel() {        
        this.setState({
            userToEdit : null
        });
    }

    onUserUpdate() {        
        this.setState({
            userToEdit : null
        }, () => {
            this.updateUsers();
        });        
    }

    onSkylineAccessChanged(value) {
        this.setState({ skylineAccess : value});
    }

    onPetroffAccessChanged(value) {
        this.setState({ petroffAccess : value});
    }

    onMobileOnlyChanged(value) {
        this.setState({ mobileOnly : value});
    }

    render() {        
        const {classes} = this.props;
        const { registrationStatus, email, apkInviteEmail, tempPassword, users, userToEdit, skylineAccess, petroffAccess, mobileOnly, backendVersion } = this.state;        
        const passwordValid = passwordValidator.validate(tempPassword);        
        const apkInviteEmailValid = emailValidator.isValid(apkInviteEmail);
        
        return(
            <div className={classes.registerUserContainer}>
                <div id='email-app-download-header' className={classes.header}>Email app install link</div>
                <div id='email-app-download-container' className={classes.registerUserInformationContainer}>
                    <Textfield
                        value={apkInviteEmail}
                        label="Recipient email"
                        id="apk-invite-email"
                        className={classes.textField}
                        helperText={
                            apkInviteEmail && !apkInviteEmailValid
                                ? 'Enter a valid address (include @ and domain)'
                                : 'Any inbox; does not need to be a portal user'
                        }
                        error={Boolean(apkInviteEmail) && !apkInviteEmailValid}
                        onChange={(event) => this.onApkInviteEmailChange(event.target)}
                    />
                    <Button
                        className={classes.btn}
                        disabled={!apkInviteEmailValid}
                        color="primary"
                        variant="outlined"
                        id="send-apk-download-email-petroff-button"
                        title="Send Petroff Android install link"
                        onClick={() =>
                            this.sendAppDownloadEmail(apkInviteEmail, 'petroff', {
                                clearTopEmailField: true
                            })
                        }
                    >
                        Petroff
                    </Button>
                    <Button
                        className={classes.btn}
                        disabled={!apkInviteEmailValid}
                        color="primary"
                        variant="outlined"
                        id="send-apk-download-email-skyline-button"
                        title="Send Skyline Android install link"
                        onClick={() =>
                            this.sendAppDownloadEmail(apkInviteEmail, 'skyline', {
                                clearTopEmailField: true
                            })
                        }
                    >
                        Skyline
                    </Button>
                </div>
                <div id='register-user-header' className={classes.header}>Register User</div>
                <div id='register-user-info-container' className={classes.registerUserInformationContainer}>
                    <Textfield 
                        value={email.toLowerCase()} 
                        label="email" 
                        id="email"
                        className={classes.textField}
                        onChange={(event) => this.onUserToRegisterInfoChange(event.target)}/>                 
                    <ValidatePasswordField
                        value={tempPassword}
                        label="temporary password"
                        id="tempPassword"
                        className={classes.textField}
                        onChange={(event) => this.onUserToRegisterInfoChange(event.target)}/>                    
                    <FormControlLabel
                        id="skyline-access-checkbox"
                        label="Skyline Access"
                        control={<Checkbox checked={skylineAccess} onChange={event => this.onSkylineAccessChanged(event.target.checked)} />}
                    />
                    <FormControlLabel
                        id="petroff-access-checkbox"
                        label="Petroff Access"
                        control={<Checkbox checked={petroffAccess} onChange={event => this.onPetroffAccessChanged(event.target.checked)} />}
                    />
                    <FormControlLabel
                        id="mobile-only-checkbox"
                        label="Mobile Only"
                        control={<Checkbox checked={mobileOnly} onChange={event => this.onMobileOnlyChanged(event.target.checked)} />}
                    />
                    <Button
                        className={classes.btn} 
                        disabled={this.isButtonDisabled(passwordValid)}                        
                        color="primary"
                        variant="outlined"
                        id='register-button' onClick={() => this.onRegisterClick()}>Register User</Button>
                </div>
                <UsersTable
                    users={users}
                    rowClicked={(user) => { this.rowclicked(user) }}
                    onRequestAppDownloadEmail={(email, company) => this.sendAppDownloadEmail(email, company)}
                />
                <div className={classes.header}>Taxes</div>
                <div id='register-user-info-container' className={classes.registerUserInformationContainer}>
                    <Textfield
                        value={this.state.tax}
                        label="Parts Tax %"
                        id="partsTax"
                        className={classes.textField}
                        InputProps={{
                            inputComponent: NumberFormatCustom,
                            id: "partsTax"
                        }}
                        onChange={(e) => {                            
                            const enabled = this.state.tax !== e.target.value;
                            this.setState({ tax: e.target.value, taxSaveDisabled : !enabled })
                        }} />
                    <Button
                        className={classes.btn}
                        disabled={this.state.taxSaveDisabled}
                        color="primary"
                        variant="outlined"
                        id='save-tax-button' onClick={() => { invoiceService.updateTax(this.state.tax / 100.00)} }>Save Tax Rate</Button>
                </div>
                <div>                    
                    <div className={classes.versionItemContainer}>                        
                        <div className={classes.versionItemLabel}>Backend Version:</div>
                        <div className={classes.versionItem}>{backendVersion}</div>
                    </div>
                    <div className={classes.versionItemContainer}>                        
                        <div className={classes.versionItemLabel}>Web Client Version:</div>
                        <div className={classes.versionItem}>{packageJson.version}</div>
                    </div>
                </div>
                {!!userToEdit ? <EditUserDialog userToEdit={userToEdit} onCancel={() => this.onUserEditCancel()} onUpdateUser={() => {this.onUserUpdate()}}/> : null}
                <Snackbar
                    id='registration-status-snackbar'
                    open={registrationStatus.open}
                    message={registrationStatus.message}
                    variant={registrationStatus.variant}
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center',}}
                    onClose={() => this.setState({registrationStatus: {open: false}})}
                />                
            </div>
        )
    }
}

export default withStyles(styles)(AdminContainer);